import React, { Component } from "react";
import PropTypes from "prop-types";
import { Platform, StyleSheet, View } from "react-native";
import { Button } from "native-base";
import Icon from "react-native-vector-icons/Ionicons";
import { WebView } from "react-native-webview";
import { getWritingBoardHtml } from "../../utils/HanziWriterHelper";

const isIos = Platform.OS === "ios";



class WritingBoard extends Component {

    render() {
        const html = getWritingBoardHtml();
        const writingChar = html.replace("%char%", this.props.char)

        return (
            <>
                <View style={{ height: 330, marginTop: 10 }}>
                    <WebView
                        source={{ html: writingChar, baseUrl: "web/" }}
                        style={{ flex: 1 }}
                        mixedContentMode="always"
                        originWhitelist={["*"]}
                        ref={webView => (this.webView = webView)}
                        onMessage={event => {
                            this._handleWritingChar(event.nativeEvent.data);
                        }}
                    />
                </View>
                <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "center", marginTop: 20 }}>
                    {this.props.mode === 0 ? <Button
                        transparent
                        style={[styles.centerAlign, { marginRight: 20, height: 64 }]}
                        onPress={() => {
                            this.webView.postMessage("animate");
                        }}>
                        <Icon size={48} name="ios-play-circle" color="#ffb400" />
                    </Button> : null}
                    <Button
                        transparent
                        style={[styles.centerAlign, { marginLeft: 20, height: 64 }]}
                        onPress={() => {
                            this.webView.postMessage("quiz");
                        }}>
                        <Icon size={48} name="ios-create" color="#ffb400" />
                    </Button>
                </View>
            </>
        )
    }

    _handleWritingChar = message => {
        this.props.handleWritingChar && this.props.handleWritingChar(message);
    };
}

const styles = StyleSheet.create({
    centerAlign: {
        justifyContent: "center",
        alignItems: "center",
    },
});

WritingBoard.propTypes = {
    char: PropTypes.string,
    handleWritingChar: PropTypes.func,
};

WritingBoard.defaultValue = {
    char: "",
    handleWritingChar: null,
};

export default WritingBoard;
